module.exports = __webpack_public_path__ + "static/map-704f7ebc75f1eafe619a64e556449b78.svg";